import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "completed-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPayed && _ctx.isInvoiced)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          onClick: _ctx.printReceipt,
          class: "action",
          color: "blue"
        }, {
          default: _withCtx(() => [
            (_ctx.receiptLoading)
              ? (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 0,
                  class: "animate-spin",
                  type: "mdi",
                  path: _ctx.loadingIcon
                }, null, 8, ["path"]))
              : (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 1,
                  type: "mdi",
                  path: _ctx.receiptIcon
                }, null, 8, ["path"])),
            _createTextVNode("Skriv ut kvittering ")
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.isInvoiced && _ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          type: "a",
          href: _ctx.invoiceUrl,
          target: "_blank",
          class: "action",
          color: "gray"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              type: "mdi",
              path: _ctx.invoiceIcon
            }, null, 8, ["path"]),
            _createTextVNode("Vis Faktura "),
            _createVNode(_component_SvgIcon, {
              class: "icon-small",
              type: "mdi",
              path: _ctx.externalIcon
            }, null, 8, ["path"])
          ]),
          _: 1
        }, 8, ["href"]))
      : _createCommentVNode("", true),
    (_ctx.isInvoiced && _ctx.clientEmail && _ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          class: "action",
          type: "a",
          href: _ctx.invoiceEmailUrl,
          color: "gray"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              type: "mdi",
              path: _ctx.emailIcon
            }, null, 8, ["path"]),
            _createTextVNode("Send faktura e-post ")
          ]),
          _: 1
        }, 8, ["href"]))
      : _createCommentVNode("", true)
  ]))
}